export const EXCLUDED_CATEGORY_NAMES = [
  'Constant Companion',
];

export const EXCLUDED_QUALITY_IDS = [
  22390, // Penny
];
